import React from 'react';
import { Box, Typography } from '@mui/material';
import "../css/BlueTile.css"; // External CSS

const BlueTile = ({ title, subtitle, imageSrc, containerStyles = {}, imageStyles = {} }) => {
  
  return (
    <Box className="blue-tile" sx={{ ...containerStyles }}>
      {/* Left Side: Title and Subtitle */}
      <Box className="text-container">
        <h2 variant="h6" className="tile-title">
          {title}
        </h2>
        <Typography variant="body2" className="tile-subtitle">
          {subtitle}
        </Typography>
      </Box>

      {/* Right Side: Image */}
      <Box className="image-container" sx={{ ...imageStyles }}>
        <img src={imageSrc} alt="Tile" className="main-image" />
      </Box>

      {/* <Box className="edit-icon">
        <img
          src={require('../assets/images/edit.png')}
          alt="Edit"
          className="edit-image"
        />
      </Box> */}
    </Box>
  );
};

export default BlueTile;
